export default __webpack_public_path__ + "static/media/logo1.09c6a1a5.png";